// extracted by mini-css-extract-plugin
export default {"scrollableArea":"LivePreview_scrollableArea__bFUQK","livePreviewContainer":"LivePreview_livePreviewContainer__3dVkx","backIcon":"LivePreview_backIcon__8xaaY"};